import SellerDescription from './SellerDescription.vue'

export default SellerDescription
